/**
 * Task section provider for Global Search (list API → SearchHit).
 */

import type { GlobalSearchSectionProvider } from '@/shared/search/types';
import { taskAPI, TASK_STATUS_LABELS } from '../api/task.api';
import { buildTasksUrl } from '../utils/taskViewParams';

export const taskSearchProvider: GlobalSearchSectionProvider = {
  id: 'tasks',
  permission: 'task:read',
  titleKey: 'globalSearchTasks',
  iconId: 'tasks',
  rankByAcronym: false,
  search: async (query, { limit }) => {
    const res = await taskAPI.getAll({
      search: query,
      limit,
    });
    return (res.data ?? []).slice(0, limit).map((task) => ({
      id: task.id,
      sectionId: 'tasks',
      primary: task.title,
      secondary: TASK_STATUS_LABELS[task.status] || task.status,
      path: buildTasksUrl({ view: 'list', mine: true, taskId: task.id }),
    }));
  },
};
